export default class Animation {
    constructor($catch, $posArr) {
        this.$logo = document.querySelector('.mv__logo');
        this.$catch = $catch;
        this.$posArr = $posArr;
        this._init();
    }

    _init() {
        this._lastTransitionend();

        if (!MAIN.isVisit) return;

        // ロゴにアニメーションを設定
        this.setLogo(1000);

        // 各位置の属性値を設定
        this.setPos(2000);
    }

    _lastTransitionend() {
        const $last = this.$catch.lastElementChild;
        $last.addEventListener('transitionend', () => this._hideNext(), { once: true });
    }

    _hideNext() {
        const condition = this.progress == null || this.progress >= this.$posArr.length - 1;

        // 位置単位で表示する順番・全体の進捗を設定
        condition ? this._setOrder() : this.progress++;

        const index = this.order[this.progress],
            $active = this.$posArr[index].querySelector('.-active');

        $active.style.opacity = 0;
    }

    _setOrder() {
        this.progress = 0;
        this.order = [...Array(this.$posArr.length).keys()];

        for (let i = this.order.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.order[i], this.order[j]] = [this.order[j], this.order[i]];
        }
    }

    setLogo(delay = 0) {
        setTimeout(() => this.$logo.classList.add('-active'), delay);
    }

    setPos(delay = 0) {
        this.$posArr.forEach(($pos, i) => {
            $pos.delay = delay + i * 50;
            $pos.progress = 0;
            this._setItem($pos);
        });
    }

    _setItem($pos) {
        setTimeout(() => {
            // 進捗に応じてアイテムを表示
            this._showCurrent($pos);

            // 各アイテムのアニメーション終了後に表示／非表示等を設定
            [...$pos.children].forEach(($item) => this._itemTransitionend($item, $pos));
        }, $pos.delay);
    }

    _showCurrent($pos) {
        const $current = [...$pos.children][$pos.progress];

        $current.classList.add('-active');
    }

    _itemTransitionend($item, $pos) {
        $item.addEventListener('transitionend', (e) => {
            if (!e.target.classList.contains('-active')) return;
            $pos.progress = $pos.childElementCount - 1 > $pos.progress ? $pos.progress + 1 : 0;
            $item.classList.remove('-active');
            $item.removeAttribute('style');
            this._showCurrent($pos);
            this._hideNext();
        });
    }
}
